<template>
    <div class="container-document">
        <div class="menu-list">
            <ul>
                <li v-for="item in contentList" :key="item.title">
                    <a :href="`#${item.title}`">{{ item.title }}</a>
                </li>
            </ul>
        </div>
        <div class="document-content">
            <!-- <p>
            <video src="/api/attachment/video/geneasso-en.mp4" controls="controls" width="70%">
          您的浏览器不支持该视频播放
          </video>
        </p>
        <p style="color: red; font-weight: bold; margin-top: 30px; font-size: 15px;">Note: GENEasso now features automatic recognition of separators and identifiers, a feature not covered in this video. Please refer to the website for the latest updates. </p> -->

            <div class="word-content" v-for="item in contentList" :key="item.title" v-if="item.content">
                <div class="title" :id="item.title">{{ item.title }}</div>
                <div class="content" v-if="item.title != 'Data Processing' && item.title!='Gene-Based Association Study Methods and Citations'">
                    <img v-if="item.img" :src="item.img" style="width: 100%; height: 400px;" />
                    <p v-for="item in item.content">{{ item }}</p>
                </div>

                <div v-if="item.showImg">
                    <img src="/images/about.png" style="width: 100%; margin-bottom: 10px;" />
                    <div class="content" style="text-align: center; font-size: 20px; font-weight: bold;">
                        GENEasso accelerates research by enabling efficient discovery and prioritization of disease-associated genes.
                    </div>
                </div>

                <div class="content" v-if="item.title == 'Data Processing'">
                    <!-- <div class="subtitle">Data Processing</div> -->
                    <p>GENEasso integrates GWAS summary statistics from both UK Biobank and non-UK Biobank sources to ensure broad population coverage and comprehensive trait representation.</p>
                    <p>For UK Biobank-derived data, disease-related summary statistics were compiled from three major resources: Gene ATLAS, GWAS ATLAS, and Neale Lab UKBB v3. These datasets differ in sample composition, association models, and quality control pipelines, offering complementary perspectives on disease associations within the UK Biobank cohort.</p>
                    <p>Non-UK Biobank GWAS summary statistics were obtained from a range of publicly available repositories, including LD Hub, GRASP, PhenoScanner, GWAS Catalog, and dbGaP, as well as consortium websites such as PGC, MAGIC, SSGAC, and JENGER. Only datasets accompanied by peer-reviewed publications and with clearly reported population details, sample sizes, and case-control definitions were included.</p>
                    <p>To avoid redundancy, duplicate records were filtered by retaining only the version containing the most comprehensive and relevant statistical information per publication. Metadata such as trait description, ancestry, and sample characteristics were systematically retained to support downstream filtering and stratified analyses.</p>
                    <p>For downstream gene-based association modeling and accurate linkage disequilibrium (LD) estimation, all summary statistics were mapped to one of the five 1KGP-defined super-populations—AFR, AMR, EAS, EUR, SAS—or to a mixed population category, based on reported ancestry information.</p>

                    
                </div>

                <div class="content" v-if="item.title == 'Gene-Based Association Study Methods and Citations'">
                    <!-- <div class="subtitle">Gene-Based Association Study Methods and Citations</div> -->
                    <p>GENEasso integrates seven gene-based association methods, each capturing different genetic mechanisms underlying complex traits:</p>
                    <p><b>PASCAL:</b> summarizes SNP-level associations into gene and pathway scores using analytical chi-square-based statistics, enabling pathway-level enrichment analyses with high computational efficiency.</p>
                    <p style="font-size: 16px;">Lamparter D, Marbach D, Rueedi R, et al. Fast and rigorous computation of gene and pathway scores from SNP-based summary statistics[J]. PLoS computational biology, 2016, 12(1): e1004714.</p>
                    <p><b>SMR:</b> combines GWAS and eQTL data to identify genes whose expression may mediate trait associations. GENEasso enhances SMR performance by integrating tissue-specific eQTL reference panels using deTS.</p>
                    <p style="font-size: 16px;">Zhu, Z., Zhang, F., Hu, H., Bakshi, A., Robinson, M. R., Powell, J. E., ... & Yang, J. (2016). Integration of summary data from GWAS and eQTL studies predicts complex trait gene targets. Nature genetics, 48(5), 481-487.</p>
                    <p><b>MAGMA:</b> performs multiple regression-based gene and gene-set analysis, accounting for LD between SNPs and enabling flexible modeling of gene sets and continuous gene features.</p>
                    <p style="font-size: 16px;">De Leeuw, C. A., Mooij, J. M., Heskes, T., & Posthuma, D. (2015). MAGMA: generalized gene-set analysis of GWAS data. PLoS computational biology, 11(4), e1004219.</p>
                    <p><b>DEPICT:</b> prioritizes genes in trait-associated loci based on predicted gene functions and co-expression patterns, and highlights enriched tissues and pathways relevant to the trait (Pers et al., 2015).</p>
                    <p style="font-size: 16px;">Pers, T. H., Karjalainen, J. M., Chan, Y., Westra, H. J., Wood, A. R., Yang, J., ... & Franke, L. (2015). Biological interpretation of genome-wide association studies using predicted gene functions. Nature communications, 6(1), 5890.</p>
                    <p><b>RWAS:</b> explores regulatory annotations—such as enhancers and promoters—at the genome-wide scale to identify regulatory elements and genes contributing to disease susceptibility.</p>
                    <p style="font-size: 16px;">Grishin, D., & Gusev, A. (2022). Allelic imbalance of chromatin accessibility in cancer identifies candidate causal risk variants and their mechanisms. Nature genetics, 54(6), 837-849.</p>
                    <p><b>LDAK-GBAT:</b> enables gene-based testing under flexible heritability models, providing robust power across traits with heterogeneous genetic architectures (Berrandou et al., 2023).</p>
                    <p style="font-size: 16px;">Berrandou, T. E., Balding, D., & Speed, D. (2023). LDAK-GBAT: Fast and powerful gene-based association testing using summary statistics. The American Journal of Human Genetics, 110(1), 23-29.</p>
                    <p><b>CWAS :</b> incorporates chromatin accessibility and gene-regulatory context into association modeling, improving prioritization of functionally relevant genes across tissues.</p>
                    <p style="font-size: 16px;">Baca, S. C., Singler, C., Zacharia, S., Seo, J. H., Morova, T., Hach, F., ... & Freedman, M. L. (2022). Genetic determinants of chromatin reveal prostate cancer risk mediated by context-dependent gene regulation. Nature genetics, 54(9), 1364-1375.</p>
                    </div>

                <div class="echarts-box content" v-if="item.showChart">
                    <!-- <div class="subtitle">Data Statistics</div> -->
                        <p>GENEasso has curated 8,226 high-quality GWAS summary statistics from the above resources, with pre-fine-mapping quality control applied. Among these summary statistics, 4,294 belong to UKBB cohorts and 3,932 belong to non-UKBB cohorts, with 95.34% of studies from the EUR super-population. GENEasso currently holds 726,122 pairs of disease tissue/potential causal gene associations, 225,395 of them are unique pairings identified. The average number of associations per gene is 11.37. The traits reported in the included GWAS publications are manually mapped to the Experimental Factor Ontology (EFO). Quality control steps are taken to ensure that the curated summary statistics meet the input requirements for following analysis, including steps to obtain missing variant coordinates and rsIDs, determine effect and non-effect alleles, estimate MAF, and discard incomplete statistics.</p>
                    <!--<div class="echarts-item">
                        <div ref="echarts1" id="echarts1" style="width: 100%; height: calc(100% - 30px)" />
                    </div> -->
                    <div class="echarts-item">
                        <div class="subtitle">Distribution of Gene Type</div>
                        <div ref="echarts3" id="echarts2" style="width: 100%; height: calc(100% - 30px)" />
                    </div>
                    <div class="echarts-item">
                        <div class="subtitle">Distribution of Trait Type</div>
                        <div ref="echarts2" id="echarts3" style="width: 100%; height: calc(100% - 30px)" />
                    </div>
                </div>
            </div>


            <!-- <div class="word-content">
                <div class="title">FAQ</div>
                <div class="content">
                    <p>To contact the GENEasso team, with queries, comments or feedback please email chen.cao@ucalgary.ca, guning@nju.edu.cn </p>

                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
let contentList = [
    {
        title: "About GENEasso",
        content: [
            "GENEasso is a comprehensive, curated database of disease-gene associations derived from large-scale GWAS summary statistics. Its primary goal is to support the identification of credible candidate genes associated with complex traits and to assist researchers in post-GWAS functional exploration. ",
            "The database module integrates over 8,226 high-quality, curated GWAS summary datasets across diverse populations, yielding more than 700,000 significant disease-gene association results. These associations are computed using seven state-of-the-art gene-based association methods, including four established algorithms (PASCAL, SMR, MAGMA, DEPICT) and three emerging models (CWAS, RWAS, LDSC-LDAK). Each model is implemented through its respective best-practice pipeline to ensure methodological rigor and reproducibility.",
            "Users can interactively explore disease-gene associations at both the gene and disease levels, filter by population or method, and access association significance, effect statistics, and convergence across models. All data and results are freely downloadable, and updated regularly through a continuous curation process.",
            "The platform also includes an integrated analysis module, which allows researchers to upload their own GWAS summary statistics and perform gene-based association analysis using the same curated methods and reference panels. This module supports population-specific modeling, tissue relevance prediction (via the deTS framework), and interactive visualization such as Manhattan and Venn plots. Users can compare their results against a built-in repository of 2,491 disease traits to assess replication and credibility."  ,
            "Through its combination of comprehensive coverage, standardized methodology, and user-friendly exploration tools, GENEasso serves as a valuable resource for understanding the genetic architecture of complex diseases and prioritizing genes for downstream experimental validation."  
        ],
        showImg: true
    },
    // {
    //     title: "Gene Analysis & Comparison (Replication)",
    //     content: [
    //         "Step 1. Selecting Methods: You will see a list of gene-based association methods at the top of the page. These include LDAK-GBAT, RWAS, CWAS, TF-TWAS, FUSION-TWAS, MAGMA, DEPICT, and SMR. Choose the methods you wish to include in your analysis by clicking on the checkboxes next to each method name. A blue checkmark indicates that the method is selected.",
    //         "Step 2. Selecting Methods. For each selected method, configure the 'P' value thresholds, which typically start at 0.05. Use the '+' or '-' to adjust these values as needed for your analysis. Some methods may require additional parameters: TF-TWAS and FUSION-TWAS: Choose the relevant tissue from the dropdown menu for which the association will be analyzed. FUSION-TWAS: Select the model (e.g., LASSO) from the dropdown menu. MAGMA: Enter the gene window parameter that specifies the genomic range around the gene to be considered. DEPICT and SMR: Configure any additional options that are available, such as eQTL database selection.",
    //         "Step 3. Once all configurations are set, navigate to the bottom of the page and click the 'Submit' button. After submission, you will receive a job ID. This unique identifier is critical for tracking the progress and accessing the results of your analysis. Make sure to note this down or keep the email that you will receive containing the job ID.",
    //         "\"Results\" section of our analysis, the Manhattan Plot provides a visual representation of genetic associations across various chromosomes. This plot distinguishes between \"Personal\" findings from the user's uploaded GWAS summary statistics and \"Archival\" data from GENEasso's extensive resources with the same trait as selected by the user. Each point on the plot represents a gene, with its position reflecting its genomic location and its vertical height indicating the -log10 p-value, which signifies the strength of the association. Different colors denote different gene-based association methods, allowing for an immediate visual differentiation between the results of each method. By hovering over any dot, users can obtain detailed information about that gene's association, including the associated trait, statistical significance, and method used. The option to 'Enable Display Gene Label' allows users to view gene names directly on the plot, facilitating easy identification of regions of interest. This comprehensive tool is instrumental for researchers seeking to compare their results with previously established findings, offering critical insights for replication and validation efforts in research.",
    //         "\"Resource-Derived Significant Genes\" in the \"Results\" section refers to a curated collection of gene association data for various traits, meticulously compiled from an extensive array of previously collected GWAS summary statistics within the GENEasso resource. This dataset is crucial for replication efforts, as it allows researchers to confirm the consistency and reliability of their findings against a backdrop of established associations. The ability to compare current results with this resource-derived data is essential for reinforcing the validity of new discoveries and for enhancing the overall robustness of research."
    //     ],
    // },
    // {
    //     title: "Trait-specific Tissue Calculation",
    //     content: [
    //         "This step-by-step guide will walk you through using this feature to identify the tissues that may causally contribute to the diseases studied in your GWAS summary statistics.",
    //         "Step 1. Ensure that your GWAS summary statistics file is formatted correctly with the necessary identifiers. Required fields include rsID, P-value, Beta, Non-Effect Allele Identifier, and Effect Allele Identifier. Optional fields are Chromosome and Genomic Position. The file should be in a compressed .gz format for efficient processing.",
    //         "Step 2: Data Upload. lick 'Choose File' to upload your GWAS summary statistics file from your local computer. After selection, click 'Load data' to import your file into the system.",
    //         "Step 3: Configuring File Separator. Choose the appropriate separator that matches the one used in your file, such as a comma, semicolon, or tab.",
    //         "Step 4: Setting Identifiers. In the dropdown menus provided, select the column headers from your file that correspond to the required identifiers.",
    //         "rsID Identifier: The column header for the Reference SNP cluster ID.",
    //         "P-Value Identifier: The column header for the P-values.",
    //         "Beta Identifier: The column header for the Beta values indicating effect sizes.",
    //         "Effect Allele Identifier: The column header for the Effect Allele.",
    //         "Non-Effect Allele Identifier: The column header for the Non-Effect Allele.",
    //         "Select additional identifiers for Chromosome and Genomic Position if present in your file.",
    //         "Step 5: Analysis Submission. With all fields accurately completed, click the 'Submit' button to initiate the analysis. GENEasso will analyze the provided data to identify the Trait-specific Tissues involved in the disease mechanisms indicated by your GWAS data.",
    //         "Step 6: Job Submission and Results Notification Upon submission of your data for analysis, you will immediately receive a unique job ID. Make note of this job ID as it is essential for tracking the progress of your analysis.",
    //         "A confirmation, including your job ID, will also be sent to your provided email address.",
    //         "You can use the job ID to check the status of your job at any time on the webserver.",
    //         "When your job is completed, you will receive another email notification. This email will contain a direct link to the results webpage. On the results page, you will be able to view the final analysis and identify the Trait-specific Tissue for your GWAS data. This is done by selecting the minimum p-value across all GTEx tissues, which will highlight the most significant tissue associations.",
    //     ],
    // },
    {
        title: "Data Processing",
        content: [
            //"As of 2023-6-15， GANENA has curated 8,903 high-quality GWAS summary statistics from the above resources, with pre-fine-mapping quality control applied. Among these summary statistics, 5,732 belong to UKBB cohorts and 3,171 belong to non-UKBB cohorts, with 95.4% of studies from the EUR super-population. GANENA currently holds 795,393 pairs of disease tissue/potential causal gene associations, 228,919 of them are unique pairings identified. The average number of associations per gene is 11.5. The traits reported in the included GWAS publications are manually mapped to the Experimental Factor Ontology (EFO). Quality control steps are taken to ensure that the curated summary statistics meet the input requirements for following analysis, including steps to obtain missing variant coordinates and rsIDs, determine effect and non-effect alleles, estimate MAF, and discard incomplete statistics.",
        ],
    },
    {
        title: 'Data Statistics',
        content: [],
        showChart: true,
    },
    {
        title: 'Gene-Based Association Study Methods and Citations',
        content: [],
    },
    
    // {
    //     title: 'Citations',
    //     content: [
    //         'If you utilize any of the following tools within the GENEasso platform, we respectfully request that you cite the corresponding references in your scholarly work:',
    //         'TF-TWAS：He J, Wen W, Beeghly A, et al. Integrating transcription factor occupancy with transcriptome-wide association analysis identifies susceptibility genes in human cancers. Nat Commun. 2022;13(1):7118. Published 2022 Nov 19. doi:10.1038/s41467-022-34888-0',
    //         'SMR：Zhu Z, Zhang F, Hu H, et al. Integration of summary data from GWAS and eQTL studies predicts complex trait gene targets. Nat Genet. 2016;48(5):481-487. doi:10.1038/ng.3538',
    //         'MAGMA：de Leeuw CA, Mooij JM, Heskes T, Posthuma D. MAGMA: generalized gene-set analysis of GWAS data. PLoS Comput Biol. 2015;11(4):e1004219. Published 2015 Apr 17. doi:10.1371/journal.pcbi.1004219',
    //         'PASCAL：Lamparter D, Marbach D, Rueedi R, Kutalik Z, Bergmann S. Fast and Rigorous Computation of Gene and Pathway Scores from SNP-Based Summary Statistics. PLoS Comput Biol. 2016;12(1):e1004714. Published 2016 Jan 25. doi:10.1371/journal.pcbi.1004714',
    //         'DEPICT：Pers TH, Karjalainen JM, Chan Y, et al. Biological interpretation of genome-wide association studies using predicted gene functions. Nat Commun. 2015;6:5890. Published 2015 Jan 19. doi:10.1038/ncomms6890',
    //         'CWAS：Baca SC, Singler C, Zacharia S, et al. Genetic determinants of chromatin reveal prostate cancer risk mediated by context-dependent gene regulation. Nat Genet. 2022;54(9):1364-1375. doi:10.1038/s41588-022-01168-y',
    //         'LDAK-GBAT：Berrandou TE, Balding D, Speed D. LDAK-GBAT: Fast and powerful gene-based association testing using summary statistics. Am J Hum Genet. 2023;110(1):23-29. doi:10.1016/j.ajhg.2022.11.010',
    //         'FUSION-TWAS：Gusev A, Ko A, Shi H, et al. Integrative approaches for large-scale transcriptome-wide association studies. Nat Genet. 2016;48(3):245-252. doi:10.1038/ng.3506',
    //         'deTS：Pei G, Dai Y, Zhao Z, Jia P. deTS: tissue-specific enrichment analysis to decode tissue specificity. Bioinformatics. 2019;35(19):3842-3845. doi:10.1093/bioinformatics/btz138'
    //     ]
    // },
    {
        title: "FAQ",
        content: [
            "Should you have any inquiries, comments, or feedback about GENEasso, please feel free to contact Prof. Chen Cao at caochen@njmu.edu.cn or Prof. Ning Gu at guning@nju.edu.cn."
        ]
    }
    /*
    {
        title: "Citation",
        content: [
            "If you use the rare variant association at GENEasso, please cite the related literatures:",
            "Li Z, Li X, Zhou H, et al. A framework for detecting noncoding rare-variant associations of large-scale whole-genome sequencing studies[J]. Nature Methods, 2022: 1-13.",
            "Li X, Quick C, Zhou H, et al. Powerful, scalable and resource-efficient meta-analysis of rare variant associations in large whole genome sequencing studies[J]. Nature genetics, 2023, 55(1): 154-164.",
            "Wu M C, Lee S, Cai T, et al. Rare-variant association testing for sequencing data with the sequence kernel association test[J]. The American Journal of Human Genetics, 2011, 89(1): 82-93.",
            "Li B, Leal S M. Methods for detecting associations with rare variants for common diseases: application to analysis of sequence data[J]. The American Journal of Human Genetics, 2008, 83(3): 311-321.",
            "Povysil G, Petrovski S, Hostyk J, et al. Rare-variant collapsing analyses for complex traits: guidelines and applications[J]. Nature Reviews Genetics, 2019, 20(12): 747-759.",
            "Backman J D, Li A H, Marcketta A, et al. Exome sequencing and analysis of 454,787 UK Biobank participants[J]. Nature, 2021, 599(7886): 628-634.",
            "Fiziev P P, McRae J, Ulirsch J C, et al. Rare penetrant mutations confer severe risk of common diseases[J]. Science, 2023, 380(6648): eabo1131.",
        ],
    },+
    */
];

export default {
    name: "document",

    data() {
        return {
            contentList,
        };
    },

    mounted() {
        setTimeout(() => {
            this.contentList[3].showChart = true;
            this.$nextTick(() => {
                // this.draw1();
                this.draw2();
                this.draw3();
                // this.draw4();
            })
        }, 500)
    },

    methods: {
        async getEchartsData1() {
            let res = await this.$ajax.get("");
            const data = res.data;
            this.draw1(data);
        },
        async getEchartsData2() {
            let res = await this.$ajax.get("");
            const data = res.data;
            this.draw2(data);
        },
        async getEchartsData3() {
            let res = await this.$ajax.get("");
            const data = res.data;
            this.draw3(data);
        },
        async getEchartsData4() {
            let res = await this.$ajax.get("");
            const data = res.data;
            this.draw4(data);
        },

        draw1() {
            let list = [
                { name: "2008", value: 14 },
                { name: "2009", value: 16 },
                { name: "2010", value: 22 },
                { name: "2011", value: 30 },
                { name: "2012", value: 47 },
                { name: "2013", value: 73 },
                { name: "2014", value: 86 },
                { name: "2015", value: 104 },
                { name: "2016", value: 134 },
                { name: "2017", value: 175 },
                { name: "2018", value: 1742 },
                { name: "2019", value: 2262 },
                { name: "2020", value: 2326 },
                { name: "2021", value: 4215 },
                { name: "2022", value: 6812 },
                { name: "2023", value: 8546 },
            ];
            const id = document.getElementById('echarts1');
            const echarts = this.$echarts.init(id);
            const option = {
                tooltip: {
                    show: true,
                },
                xAxis: {
                    show: true,
                    name: "Year",
                    type: "category",
                    nameGap: 25,
                    nameLocation: "center",
                    axisTick: {
                        alignWithLabel: true,
                    },
                    data: list.map((v) => v.name),
                },
                yAxis: {
                    show: true,
                    name: "Number of publications",
                    type: "value",
                    nameGap: 30,
                    nameLocation: "center",
                },
                series: [
                    {
                        data: list.map((v) => v.value),
                        type: "line",
                        smooth: true,
                    },
                ],
            };

            echarts.setOption(option);
        },

        draw2() {
            let list = [
                { name: "lncRNA", value: 1598 },
                { name: "miRNA", value: 1114 },
                { name: "misc_RNA", value: 5 },
                { name: "processed_pseudogene", value: 6 },
                { name: "protein_coding", value: 16819 },
                { name: "ribozyme", value: 1 },
                { name: "rRNA", value: 4 },
                { name: "scaRNA", value: 15 },
                { name: "snoRNA", value: 188 },
                { name: "snRNA", value: 16 },
                { name: "TEC", value: 2 },
                { name: "TR_C_gene", value: 1 },
                { name: "transcribed_processed_pseudogene", value: 44 },
                { name: "transcribed_unitary_pseudogene", value: 48 },
                { name: "transcribed_unprocessed_pseudogene", value: 15 },
                { name: "unprocessed_pseudogene", value: 18 },
            ];

            const id = document.getElementById('echarts2');
            const echarts = this.$echarts.init(id);
            const option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    type: "scroll",
                    right: 0,
                },
                series: [
                    {
                        type: "pie",
                        radius: "50%",
                        data: list,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            echarts.setOption(option);
        },

        draw3() {
            const id = document.getElementById('echarts3');

            const echarts = this.$echarts.init(id);

            let list = [
                { name: "anthropometric measurement", value: 44 },
                { name: "disease", value: 4488 },
                { name: "anatomical entity", value: 139 },
                { name: "phenotype", value: 1044 },
                { name: "material property", value: 35 },
                { name: "inflammatory bowel disease", value: 34 },
                { name: "anatomy basic component", value: 86 },
                { name: "organic heterocyclic compound", value: 114 },
                // { name: "lipid", value: 19 },
                // { name: "follow-up status", value: 24 },
                // { name: "temporal measurement", value: 12 },
                // { name: "experimental factor; Phlebitis", value: 11 },
                // { name: "drug use measurement", value: 12 },

                { name: "experimental process", value: 346 },
                // { name: "infectious disease biomarker", value: 12 },
                // { name: "mental or behavioural disorder biomarker", value: 85 },
                // { name: "inborn errors of metabolism", value: 14 },
                // { name: "anemia", value: 14 },
                // { name: "family history", value: 14 },
                // { name: "hematopoietic and lymphoid system neoplasm", value: 14 },
                { name: "self-reported trait", value: 203 },
                // { name: "reproductive process", value: 12 },
                { name: "other disease", value: 316 },
                { name: "response to stimulus", value: 61 },
                // { name: "phenols", value: 21 },
                // { name: "behavior", value: 29 },
                { name: "environmental exposure measurement", value: 74 },
                // { name: "hair morphology measurement", value: 33 },

                // { name: "acid", value: 15 },
                // { name: "smoking behaviour measurement", value: 24 },
                // { name: "protein measurement", value: 21 },
                // { name: "treatment", value: 13 },
                // { name: "chemical role", value: 30 },
                // { name: "application", value: 22 },
                // { name: "derived unit", value: 20 },
                // { name: "biological role", value: 12 },
                { name: "other traits", value: 3339 },
            ];

            const option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    right: 0,
                },
                series: [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: "50%",
                        data: list,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            echarts.setOption(option);
        },
        draw4() {
            let list = [
                { name: "Collapsing analyse", value: 30444 },
                { name: "SKAT", value: 12684 },
                { name: "Burden test", value: 11468 },
                { name: "SAIGE-GENE+", value: 1434 },
                { name: "SKAT-O", value: 1034 },
                { name: "aSPU", value: 471 },
                { name: "STAAR", value: 420 },
                { name: "ACAT-V", value: 192 },
            ];

            const id = document.getElementById('echarts4');

            const echarts = this.$echarts.init(id);
            const option = {
                grid: {
                    right: 150,
                    bottom: 100,
                },
                xAxis: {
                    type: "category",
                    name: "Software",
                    data: list.map((v) => v.name),
                    axisLabel: {
                        rotate: 45,
                    },
                },
                yAxis: {
                    name: "Number of Associations",
                    type: "value",
                },
                series: [
                    {
                        data: list.map((v) => v.value),
                        type: "bar",
                    },
                ],
            };

            echarts.setOption(option);
        },
    },
};
</script>

<style lang="less" scoped>
.container-document {
    position: relative;
    display: flex;
    padding: 30px;
    .menu-list {
        position: sticky;
        top: 20px;
        width: 25%;
        height: min-content;
        background: #f8f8f8;

        color: #176b6e;

        ul {
            font-size: 18px;
            list-style: none;
            padding-left: 20px;
            margin: 0;

            li {
                cursor: pointer;
                padding: 2px 0;

                &:hover {
                    color: #563d7c;
                    font-weight: bold;
                }
            }
        }
    }

    .document-content {
        flex-basis: 100%;

        margin-left: 20px;

        .word-content {
            .title {
                padding-top: 20px;
                padding-bottom: 10px;
                font-size: 26px;
                font-weight: bold;
            }

            .subtitle {
                padding-top: 20px;
                padding-bottom: 10px;
                font-size: 26px;
            }

            .content {
                padding-left: 24px;
                font-size: 18px;
            }
        }
    }
}

.echarts-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .echarts-item {
        width: 100%;
        height: 500px;

        .title {
            font-size: 24px;
        }
    }
}
</style>
